import { useState } from "react";
import CommonModal from "./DumpModal";
import UploadFileModal from "./UploadFileModal";
import LoadURLModal from "./LoadURLModal";
import TellUsMoreModal from "./TellUsMoreModal";

const ChangeSourceModal = ({
  isOpen,
  onClose,
  currentSource,
}) => {
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openURLModal, setOpenURLModal] = useState(false);
  const [openTellUsModal, setOpenTellUsModal] = useState(false);

  const handleUploadModal = () => {
    setOpenUploadModal(!openUploadModal);
    onClose();
  };

  const handleTellUsModal = () => {
    setOpenTellUsModal(!openTellUsModal);
    onClose();
  };

  const handleURLModal = () => {
    setOpenURLModal(!openURLModal);
    onClose();
  };
  return (
    <>
      <CommonModal title="Change Source" isOpen={isOpen} onClose={onClose}>
        <div className="mt-7 group">
          <button
            onClick={handleURLModal}
            className="w-full text-left bg-muted border !border-border rounded-lg p-7 flex justify-between items-center group-hover:bg-muted-foreground/10"
          >
            <div>
              <div className="text-md mb-1 font-medium text-foreground">
                Add Your Website
              </div>
              <div className="text-sm text-muted-foreground">
                Your business website URL
              </div>
            </div>
            <span className="text-2xl text-foreground hidden group-hover:block">
              →
            </span>
          </button>
        </div>

        <div className="mt-3 mb-6 group">
          <button
            onClick={handleUploadModal}
            className="w-full text-left bg-muted border !border-border rounded-lg p-7 flex justify-between items-center group-hover:bg-muted-foreground/10"
          >
            <div>
              <div className="text-md mb-1 font-medium text-foreground">
                Upload a file
              </div>
              <div className="text-sm text-muted-foreground">
                E.g. Brochure, sales pitch or brand guidelines{" "}
              </div>
            </div>
            <span className="text-2xl text-foreground hidden group-hover:block">
              →
            </span>
          </button>
        </div>

        <div className="mt-3 mb-6 group">
          <button
            onClick={handleTellUsModal}
            className="w-full text-left bg-muted border !border-border rounded-lg p-7 flex justify-between items-center group-hover:bg-muted-foreground/10"
          >
            <div>
              <div className="text-md mb-1 font-medium text-foreground">
                Tell Us More
              </div>
              <div className="text-sm text-muted-foreground">
                Answer some questions so we can get to know you
              </div>
            </div>
            <span className="text-2xl text-foreground hidden group-hover:block">
              →
            </span>
          </button>
        </div>
      </CommonModal>
      <UploadFileModal
        isOpen={openUploadModal}
        onClose={handleUploadModal}
        setModal={setOpenUploadModal}
        currentSource={currentSource}
      />
      <LoadURLModal
        isOpen={openURLModal}
        setModal={setOpenURLModal}
        onClose={handleURLModal}
        currentSource={currentSource}
      />
      <TellUsMoreModal
        isOpen={openTellUsModal}
        onClose={handleTellUsModal}
        setModal={setOpenTellUsModal}
        currentSource={currentSource}
      />
    </>
  );
};

export default ChangeSourceModal;
